{
  "carrierLabel": "운송 회사",
  "searchPlaceholder": "이름으로 검색",
  "selectAsCarrier": "\"{name}\"을(를) 운송사로 선택",
  "typeToSearch": "회사를 검색하려면 입력하세요"
}
